import { useState } from 'react'

const useModal = () => {
  const [isVisible, setIsVisible] = useState(true);  
  const toggleModal = () => setIsVisible(!isVisible);
  
  return {
    isVisible,
    toggleModal,
    setIsVisible
  }
}

export default useModal;
